import {createContext, type ComponentProps} from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

// Lets Trigger and Content opt out together, so a caller can disable a tooltip
// without unmounting the elements it wraps.
export const TooltipContext = createContext<{disabled?: boolean}>({});

export function TooltipProvider({delayDuration = 0, ...props}: ComponentProps<typeof TooltipPrimitive.Provider>) {
	return <TooltipPrimitive.Provider data-slot="tooltip-provider" delayDuration={delayDuration} {...props}/>;
}
